import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useSession } from "../features/auth/SessionProvider";
import { useAccount } from "../features/platform/AccountProvider";
import { publicMessage } from "../shared/lib/errors";
import { ThemeToggle } from "../shared/ui/ThemeProvider";

const navItems = [
  { to: "/inicio", label: "Início", icon: "⌂" },
  { to: "/chat", label: "Assistente", icon: "✦" },
] as const;

export function AppShell() {
  const { access } = useAccount();
  const { signOut } = useSession();
  const [menuOpen, setMenuOpen] = useState(false);
  const [message, setMessage] = useState("");
  const profilesLabel = access.usageMode === "personal" ? "Meu perfil" : "Perfis";
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Pular para o conteúdo
      </a>
      <header className="mobile-header">
        <button
          aria-expanded={menuOpen}
          aria-controls="primary-nav"
          onClick={() => setMenuOpen((value) => !value)}
          type="button"
        >
          <span aria-hidden="true">☰</span><span className="sr-only">Abrir menu</span>
        </button>
        <span className="mobile-brand"><span className="brand-mark">B</span>Base Hormonal</span>
        <ThemeToggle />
      </header>
      <aside className={menuOpen ? "sidebar open" : "sidebar"}>
        <div className="brand-row">
          <span className="brand-mark">B</span>
          <strong>Base Hormonal</strong>
        </div>
        <p className="nav-section-label">Acompanhar</p>
        <nav id="primary-nav" aria-label="Navegação principal" onClick={() => setMenuOpen(false)}>
          {navItems.map((item) => <NavLink key={item.to} to={item.to}><span className="nav-icon" aria-hidden="true">{item.icon}</span>{item.label}</NavLink>)}
          <NavLink to={access.usageMode === "personal" ? "/meu-perfil" : "/alunos"}>
            <span className="nav-icon" aria-hidden="true">◎</span>{profilesLabel}
          </NavLink>
          <p className="nav-section-label">Ferramentas</p>
          <NavLink to="/configuracoes"><span className="nav-icon" aria-hidden="true">⚙</span>Configurações</NavLink>
          <NavLink to="/calculadoras"><span className="nav-icon" aria-hidden="true">▦</span>Calculadoras</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-preferences"><span>{access.usageMode === "personal" ? "Espaço pessoal" : "Espaço profissional"}</span><ThemeToggle /></div>
          <button
            type="button"
            onClick={() => {
              setMessage("");
              void signOut().catch((error: unknown) => setMessage(publicMessage(error)));
            }}
          >
            Sair
          </button>
          <p aria-live="polite">{message}</p>
        </div>
      </aside>
      {menuOpen ? (
        <button className="backdrop" aria-label="Fechar menu" onClick={() => setMenuOpen(false)} />
      ) : null}
      <main id="main-content" className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
